import Swiper from 'swiper/dist/js/swiper';

import isIEbrowser from '../../../resources/scripts/helpers/is-ie';

class BrixImageCarousel {
  static init(...parameters) {
    return new BrixImageCarousel(...parameters);
  }

  constructor(selector) {
    this.selector = selector;
    const IE = isIEbrowser();
    this.swiperContainer = selector.querySelector('.swiper-container');
    this.swiperPagination = selector.querySelector('.swiper-pagination');
    this.swiperNext = selector.querySelector('.swiper-navigation-slide-next');
    this.swiperPrev = selector.querySelector('.swiper-navigation-slide-prev');
    this.swiperActiveSlide = selector.querySelector('.active-slide');
    this.swiperTotalSlides = selector.querySelector('.total-slides');

    const enableAutoplay = this.swiperContainer.dataset.autoplay === 'true';
    const autoplayDelay = parseInt(this.swiperContainer.dataset.autoplayDelay, 10) * 1000;

    const brixCarousel = this;

    this.mySwiper = new Swiper(this.swiperContainer, {
      pagination: {
        el: this.swiperPagination,
        type: 'bullets',
        clickable: true,
        bulletElement: 'div',
      },
      navigation: {
        nextEl: this.swiperNext,
        prevEl: this.swiperPrev,
      },
      slidesPerView: 1,
      centeredSlides: true,
      autoplay: enableAutoplay ? { delay: autoplayDelay } : false,
      loop: true,
      on: {
        init() {
          brixCarousel.swiperActiveSlide.innerText = this.realIndex + 1;
        },
        slideChange() {
          brixCarousel.setCaption();
          brixCarousel.swiperActiveSlide.innerText = this.realIndex + 1;
        },
      },
    });

    this.mySwiper.on('transitionStart', () => {
      const activePaginationBullet = this.selector.querySelector('.swiper-pagination-bullet-active');
      this.highlightActivePaginationBullet();
      this.highlightHoveredPaginationBullet(activePaginationBullet);
    });

    if (this.mySwiper && IE) {
      window.objectFitPolyfill();
    }

    this.setCaption();

    this.setupHighlight();

    window.addEventListener('resize', () => {
      // Render on resize to update swiper
      this.mySwiper.update();
    });
  }

  setCaption() {
    const captionElement = this.selector.querySelector('.slide-caption');
    if (!captionElement) return;
    const { activeIndex } = this.mySwiper;
    const activeSlide = this.mySwiper.slides[activeIndex];
    captionElement.innerText = activeSlide.dataset.caption;
    if (activeSlide.dataset.caption.length === 0) {
      captionElement.classList.add('-empty');
    } else {
      captionElement.classList.remove('-empty');
    }
  }

  setupHighlight() {
    this.highlight = document.createElement('span');
    this.highlight.classList.add('highlight');
    this.swiperPagination
      .append(this.highlight);

    const paginationBullets = this.selector.querySelectorAll('.swiper-pagination-bullet');
    const paginationBulletsWrapper = this.selector.querySelector('.swiper-pagination');

    [...paginationBullets].forEach((bullet) => bullet.addEventListener('mouseover', () => {
      this.highlightHoveredPaginationBullet(bullet);
    }));

    paginationBulletsWrapper.addEventListener('mouseleave', () => {
      setTimeout(() => {
        this.highlightActivePaginationBullet();
      }, 500);
    });

    window.addEventListener('resize', (event) => this.highlightActivePaginationBullet(event));

    this.highlightActivePaginationBullet();
  }

  highlightActivePaginationBullet(event = '') {
    if (event.type === 'resize') {
      this.highlight.classList.remove('-transition');
    }

    const activePaginationBullet = this.selector.querySelector('.swiper-pagination-bullet-active');
    const activePaginationBulletCoords = activePaginationBullet.getBoundingClientRect();
    this.highlight.setAttribute(
      'style',
      `transform: translate(${activePaginationBulletCoords.left - this.swiperPagination.getBoundingClientRect().left + -1}px, 19px)`,
    );
  }

  highlightHoveredPaginationBullet(bullet) {
    if (!this.highlight.classList.contains('-transition')) {
      this.highlight.classList.add('-transition');
    }

    const bulletCoords = bullet.getBoundingClientRect();
    this.highlight.setAttribute(
      'style',
      `transform: translate(${bulletCoords.left - this.swiperPagination.getBoundingClientRect().left + -1}px, 19px)`,
    );
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-image-carousel', BrixImageCarousel.init);
}
